<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <v-layout row wrap v-if="role === 'GEM'">
        <v-flex md6 xs12>
          <v-select
            :items="laboratories"
            label="Filtrar por Laboratorio: "
            no-data-text="Datos no disponibles"
            v-model="labId"
            clearable
          ></v-select>
        </v-flex>
      </v-layout>

      <!-- KPI de tiempos del trámite: días recepción -> entrega por tramo.
           Recarga solo, observando labId. -->
      <kpi-tramite :lab-id="labId"></kpi-tramite>
    </v-container>
  </div>
</template>
<script>
import KpiTramite from './dashboard/KpiTramite'
import SessionHelper from '@/helpers/SessionHelper'
export default {
  components: {
    KpiTramite,
  },

  data() {
    return {
      laboratories: [],
      labId: null,
      role: null,
    }
  },
  created() {
    this.role = SessionHelper.role
    this.$store.dispatch('laboratories/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.laboratories.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })
  },
}
</script>
